import React, { Component, useState, useEffect } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
} from "@material-ui/core";
import { withRouter } from "react-router";
import { useTranslation, Trans } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import ReusaReusableSectionsSelecReusableSectionsSelectabletablebleSections from "./ReusableSectionsSelectable";
import ReusableSectionsSelectable from "./ReusableSectionsSelectable";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import KpsTextField from "../../KpsTextField";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
function ReusableSectionsContentDialog(props) {
  const [selectedSection, setSelectedSection] = useState({});
  const [title, setTitle] = useState("");
  const [column, setColumn] = useState("middle");

  const convertSection = () => {
    let newSection = {};
    newSection.defaultText = selectedSection.content;
    newSection.reusableSectionId = selectedSection.reusableSectionId;
    newSection.sectionColumn = column;
    newSection.type = "reusable";
    newSection.name = title;
    newSection.sortOrder = props.tempId;
    newSection.canMove = true;
    newSection.tempId = "draggable-" + props.tempId;
    newSection.customFieldsRVOs = selectedSection.customFieldsRVOs;
    props.setTempId(props.tempId + 1);
    props.onAddSection(newSection);
    props.onClose();
  };

  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Dialog open={props.open} onClose={props.onClose} fullScreen>
      <DialogTitle>Add reusable section</DialogTitle>
      <DialogContent>
        <FormControl className={classes.formControl} fullWidth>
          <KpsTextField
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            aria-label="Section title text input"
            label={"Section title"}
          />
        </FormControl>
        <ReusableSectionsSelectable
          addSection
          reusableSectionSelected={(section) => {
            setSelectedSection(section);
          }}
        />
        <FormControl className={classes.formControl} fullWidth>
          <FormLabel component="legend">Column</FormLabel>
          <RadioGroup
            aria-label="Column"
            value={column}
            onChange={(event) => setColumn(event.target.value)}
            style={{ display: "flex", flexDirection: "row" }}
          >
            <FormControlLabel value="left" control={<Radio />} label="Left" />
            <FormControlLabel
              value="middle"
              control={<Radio />}
              label="Middle"
            />
            <FormControlLabel value="right" control={<Radio />} label="Right" />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          <Trans i18nKey="global_cancel" />
        </Button>
        <Button onClick={convertSection} color="primary">
          <Trans i18nKey={"global_add"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withRouter(withTheme(ReusableSectionsContentDialog)));
